import React, { useMemo } from 'react';
import { ODataGrid } from '../../../../Components/OElements/ODataGrid';
import { Link } from 'react-router-dom';

export const ItemsSectionTable = ({ items, onRemove }) => {
	const localData = useMemo(
		() =>
			Array.isArray(items)
				? items.map((it, idx) => ({ ...it, _originalIndex: idx }))
				: [],
		[items]
	);

	// SIEMPRE las mismas columnas genéricas del DTE
	const columns = useMemo(
		() => [
			{
				header: 'Acciones',
				columnDefType: 'display',
				width: '5%',
				Cell: ({ row }) => (
					<React.Fragment>
						<div className='d-flex'>
							<div className='flex-shrink-0'>
								<ul className='list-inline mb-0'>
									<li className='list-inline-item'>
										<Link
											to='#'
											className={`remove-item-btn`}
											onClick={e => {
												onRemove(row.original._originalIndex);
											}}
										>
											<i className='ri-delete-bin-line align-bottom me-2'></i>
										</Link>
									</li>
								</ul>
							</div>
						</div>
					</React.Fragment>
				),
			},
			{
				header: '#',
				accessorFn: (_row, _index) => _index + 1,
				dataType: 'number',
			},
			{
				header: 'Código',
				accessorKey: 'VlrCodigo',
				dataType: 'string',
			},
			{
				header: 'Nombre',
				accessorKey: 'NmbItem',
				dataType: 'string',
			},

			{
				header: 'Cantidad',
				accessorKey: 'QtyItem',
				dataType: 'number',
			},
			{
				header: 'Unidad',
				accessorKey: 'UnmdItem',
				dataType: 'string',
			},
			{
				header: 'Precio Unitario',
				accessorKey: 'PrcItem',
				dataType: 'float.2',
			},
			{
				header: 'Monto',
				accessorKey: 'MontoItem',
				dataType: 'float.2',
			},
			{
				header: 'Descripción',
				accessorKey: 'DscItem',
				dataType: 'string',
			},
		],
		[onRemove]
	);

	return (
		<ODataGrid
			data={localData}
			columns={columns}
			remoteOperations={false}
			filtering={false}
			searching={false}
			withColumnBorders={true}
			defaultPageSize={10}
			getRowIdTable={row => `item_${row._originalIndex}`}
			mantineTableContainerProps={{ sx: { maxHeight: '300px' } }}
			nameFile={'detalle_items'}
			theme='minimal'
		/>
	);
};
